import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import From from '../CreateAgent/components/From/From';
// import { useParams } from 'react-router-dom';
const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default function CreateAgent(props) {

    const { className } = props;
    const classes = useStyles();

    // let {agency_id} = useParams();

    return (

        <div className={clsx(classes.root, className)} >
      
            <From {...props} classes={classes} className={className}/>
        </div>
    )
}
